import { showNotification } from "@mantine/notifications";

export function showErrorNotification(message) {
	showNotification({
		title: "Error",
		message: message,
		autoClose: 3000,
		color: "red",
		styles: { root: { backgroundColor: "#040F1F", zIndex :"1009 !important" } },
	});
}
export function showSuccessNotification(message) {
	showNotification({
		title: "Success",
		message: message,
		autoClose: 3000,
		color: "green",
		styles: { root: { backgroundColor: "#040F1F",zIndex :"1009 !important" } },
	});
}
